/**
 * Event type icon URLs from Cloudinary with category groupings
 */

export type EventCategory = 'pricing' | 'packaging' | 'product' | 'other';

export const EVENT_CATEGORIES: Record<EventCategory, { label: string; eventTypes: string[] }> = {
  pricing: {
    label: 'Pricing',
    eventTypes: ['discount_added', 'discount_changed', 'discount_removed', 'price_decreased', 'price_hidden', 'price_increased', 'price_revealed', 'pricing_restructured'],
  },
  packaging: {
    label: 'Packaging',
    eventTypes: ['addon_added', 'addon_changed', 'addon_removed', 'capacity_decreased', 'capacity_increased', 'freemium_changed', 'plan_added', 'plan_removed', 'plan_renamed', 'pricing_metric_changed', 'threshold_added', 'threshold_removed', 'trial_changed'],
  },
  product: {
    label: 'Product',
    eventTypes: ['feature_added', 'feature_changed', 'feature_removed', 'positioning_changed'],
  },
  other: {
    label: 'Other',
    eventTypes: [],
  },
};

export const EVENT_TYPE_ICONS: Record<string, string> = {
  // Packaging events
  addon_added: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090635/pricing-icons/packaging_events/addon_added.png",
  addon_changed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090636/pricing-icons/packaging_events/addon_changed.png",
  addon_removed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090637/pricing-icons/packaging_events/addon_removed.png",
  capacity_decreased: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090638/pricing-icons/packaging_events/capacity_decreased.png",
  capacity_increased: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090639/pricing-icons/packaging_events/capacity_increased.png",
  freemium_changed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090640/pricing-icons/packaging_events/freemium_changed.png",
  plan_added: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090641/pricing-icons/packaging_events/plan_added.png",
  plan_removed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090642/pricing-icons/packaging_events/plan_removed.png",
  plan_renamed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090643/pricing-icons/packaging_events/plan_renamed.png",
  pricing_metric_changed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090644/pricing-icons/packaging_events/pricing_metric_changed.png",
  threshold_added: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090650/pricing-icons/packaging_events/threshold_added.png",
  threshold_removed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090651/pricing-icons/packaging_events/threshold_removed.png",
  trial_changed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090652/pricing-icons/packaging_events/trial_changed.png",

  // Pricing events
  discount_added: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090653/pricing-icons/pricing_events/discount_added.png",
  discount_changed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090654/pricing-icons/pricing_events/discount_changed.png",
  discount_removed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090655/pricing-icons/pricing_events/discount_removed.png",
  price_decreased: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090656/pricing-icons/pricing_events/price_decreased.png",
  price_hidden: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090657/pricing-icons/pricing_events/price_hidden.png",
  price_increased: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090658/pricing-icons/pricing_events/price_increased.png",
  price_revealed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090658/pricing-icons/pricing_events/price_revealed.png",
  pricing_restructured: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090664/pricing-icons/pricing_events/pricing_restructured.png",

  // Product events
  feature_added: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090666/pricing-icons/product_events/feature_added.png",
  feature_changed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090669/pricing-icons/product_events/feature_changed.png",
  feature_removed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1770090670/pricing-icons/product_events/feature_removed.png",
  positioning_changed: "https://res.cloudinary.com/dd6dkaan9/image/upload/v1771345876/pricing-icons/product_events/positioning_changed.png",
};

/**
 * Get icon URL for an event type, returns undefined if not found
 */
export function getEventTypeIconUrl(eventType: string): string | undefined {
  return EVENT_TYPE_ICONS[eventType];
}

/**
 * Get category for an event type
 */
export function getEventCategory(eventType: string): EventCategory {
  for (const [category, config] of Object.entries(EVENT_CATEGORIES)) {
    if (config.eventTypes.includes(eventType)) {
      return category as EventCategory;
    }
  }
  return 'other';
}
